import {appendAttributionQueryParams} from "@repo/tracking/utm/lib/utm-attribution-client";
import {BEAST_ACADEMY_ENROLL_URL} from "@/lib/const";

/**
 * Opens the Beast Academy enrollment page with session UTMs and click IDs
 * copied onto the URL. Cookies cannot follow beastacademy.com.
 */
export function openBeastAcademyEnroll(): void {
	window.open(
		appendAttributionQueryParams(BEAST_ACADEMY_ENROLL_URL),
		"_blank",
		"noreferrer"
	);
}
